"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _iteratee = _interopRequireDefault(require("lodash/iteratee"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _identity = _interopRequireDefault(require("lodash/identity"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _last = _interopRequireDefault(require("lodash/last"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Will group a collection by consecutive entries (sorted).
 * ```js
 * const collection = [1, 3, 6, 2];
 * groupByConsecutive(collection); // [[1, 2, 3], [6]]
 * ```
 */
var groupByConsecutive = function groupByConsecutive(collection) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity.default;

  if ((0, _isEmpty.default)(collection)) {
    return [];
  }

  var selector = (0, _iteratee.default)(iteratee);
  var array = (0, _sortBy.default)(collection, selector);
  var groups = [[]];
  var prev = selector(array[0]);
  (0, _forEach.default)(array, function (elem) {
    var curr = selector(elem);

    if (curr - prev <= 1) {
      (0, _last.default)(groups).push(elem);
    } else {
      groups.push([elem]);
    }

    prev = curr;
  });
  return groups;
};

var _default = groupByConsecutive;
exports.default = _default;
//# sourceMappingURL=index.js.map